import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { styles } from './styles.js';
import { withStyles } from '@mui/styles';

const Container = ({ classes, children }) => {
  return <Box className={classes.root}>{children}</Box>;
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(Container);
